import { httpClient } from "../http-client/base-client";
import { ApiProduct } from "../types/product/api-types";

export const productResource = {
  async getProduct(id: number): Promise<ApiProduct> {
    const product = await httpClient.get<ApiProduct>(`product/${id}`);
    return product;
  },
};
